import { NgModule } from '@angular/core';

import { EditorComponent } from './editor.component';

@NgModule({
  imports: [ EditorComponent ],
  exports: [ EditorComponent ]
})
export class EditorModule {}
